import { render, staticRenderFns } from "./SectionMedia.vue?vue&type=template&id=4d95baab&"
import script from "./SectionMedia.vue?vue&type=script&lang=js&"
export * from "./SectionMedia.vue?vue&type=script&lang=js&"
import style0 from "./SectionMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports